// extracted by mini-css-extract-plugin
export default {"wrap":"WG-z","fullWidth":"XG-z","hideOnDesktop":"YG-z","content":"ZG-z","hasOpenedNav":"_G-z","crumbsList":"aH-z","dropdownsWrap":"bH-z"};